import React, { Component } from 'react';
import MuiAlert from '@material-ui/lab/Alert';

export default function  (props) {
    return <MuiAlert elevation={6} variant="filled" {...props} />;
}